import script from "./ClientDeviceMonitorSystemSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./ClientDeviceMonitorSystemSettings.vue?vue&type=script&setup=true&lang=js"

import "./ClientDeviceMonitorSystemSettings.vue?vue&type=style&index=0&id=2807d1a2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2807d1a2"]])

export default __exports__